import React from "react";
import ReactEcharts from "echarts-for-react";

import { campaignMetricsConstants, CAMPAIGN_METRICS_CHART_OPTIONS, CAMPAIGN_METRICS_CHART_SERIES, CAMPAIGN_METRICS_LABELS } from "../../constants";

const { DELIVERY_COUNT, UNIQUE_CUSTOMER_COUNT } = campaignMetricsConstants;

const Charts = (props) => {
  const { data } = props;

  //Creating unique task array from task inside data
  const tasksArray = data?.tasks ?? [];
  const newArray = [
    { name: DELIVERY_COUNT, value: tasksArray.map((t) => t.deliveryCount) },
    {
      name: UNIQUE_CUSTOMER_COUNT,
      value: tasksArray.map((t) => t.uniqueCustomerCount),
    },
  ];

  //Options for charts to show data
  const option = {
    ...CAMPAIGN_METRICS_CHART_OPTIONS,
    xAxis: [
      {
        type: "category",
        axisTick: { show: false },
        data: tasksArray.map((loc) =>
          loc.isDeleted ? ` ${loc.title} ${CAMPAIGN_METRICS_LABELS.DELETED}` : loc.title
        ),
      },
    ],
    yAxis: [
      {
        type: "value",
      },
    ],
    series: newArray.map((obj) => {
      return {
        name: obj.name,
        ...CAMPAIGN_METRICS_CHART_SERIES,
        data: obj.value,
      };
    }),
  };

  return (
    <div className="mx-5 my-2" aria-label="chart">
      <ReactEcharts
        option={option}
        className="mx-auto chart-styling pe-1 pt-2 rounded"
      />
    </div>
  );
};

export default Charts;
